// client/src/services/auditService.js
/**
 * Service de consultation du journal d'audit d'activité des guichetiers.
 * Lecture réservée (permission audit.view : admin/manager) — le jeton Bearer est
 * porté par `axios.defaults` (configuré à la connexion / dans ProtectedRoute).
 * @author Dr Hamid MADANI <drmdh@msn.com>
 */
import axios from 'axios';

const API_URL = '/api/audit';

const auditService = {
  /** Liste paginée + filtrée : { entries, total, page, limit }. */
  list: async (params = {}) => {
    const response = await axios.get(API_URL, { params });
    return response.data.data;
  },
  /** Export CSV du journal filtré (Blob). */
  exportCsv: async (params = {}) => {
    const response = await axios.get(`${API_URL}/export.csv`, { params, responseType: 'blob' });
    return response.data;
  },
};

export default auditService;
